import { render } from "./PriceIncreaseTable.vue?vue&type=template&id=e25e72b6&scoped=true"
import script from "./PriceIncreaseTable.vue?vue&type=script&lang=js"
export * from "./PriceIncreaseTable.vue?vue&type=script&lang=js"

import "./PriceIncreaseTable.vue?vue&type=style&index=0&id=e25e72b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e25e72b6"]])

export default __exports__